"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import indiahiringqr from "./indiahiringqr.png"

export function DownloadAppBanner() {
    const [isVisible, setIsVisible] = useState(true)

    if (!isVisible) {
        return null
    }

    return (
        <div className="fixed bottom-4 right-7 z-50 rounded-md p-2 shadow-md bg-[#F6F9FC] w-[320px] h-[130px] border border-purple-100 overflow-hidden" >
            {/* <button
                aria-label="Close banner"
                onClick={() => setIsVisible(false)}
                className="absolute top-1 right-1 p-1 rounded-full hover:bg-purple-200 transition-colors"

            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-3 h-3"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button> */}

            <div className="flex items-center h-full">
                {/* QR Code Section */}
                <div className="flex flex-col items-center px-2 border-r border-purple-200 h-full justify-center">
                    <img
                        src={indiahiringqr}
                        width={70}
                        height={70}
                        alt="Scan to download app"
                        className="rounded-sm object-contain"
                    />
                    <p className="text-[9px] text-gray-600 mt-1">
                        Scan to install
                    </p>
                </div>

                {/* Content Section */}
                <div className="flex flex-col pl-3 pr-1 w-full">
                    <p className="text-[12px] font-bold text-purple-800 mb-1">
                        Download App
                    </p>
                    <p className="text-[10px] text-gray-600 mb-2">
                        Find jobs with a simple swipe
                    </p>

                    <Link to="#" className="block w-full">
                        <div className="flex items-center bg-black text-white rounded-sm px-2 py-1 justify-center text-[10px] w-full">
                            <svg viewBox="0 0 24 24" width={12} height={12} fill="currentColor" className="mr-1">
                                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                            </svg>
                            <span className="text-[10px]">GET IT ON</span>
                        </div>
                        <p className="text-[10px] font-bold text-center mt-[1px]">
                            Google Play
                        </p>
                    </Link>

                    {/* <div className="flex items-center   justify-center">
                        <p className="text-[9px] text-gray-600">
                            ★4.6 (655K reviews)
                        </p>
                    </div> */}
                </div>
            </div>
        </div>
    )
}